// MT-042: el proxy del servidor niega abrir un expediente (403) cuando falta el vínculo asistencial vigente o el consentimiento vigente. La respuesta es un
// OperationOutcome con el motivo en `issue[0].details.coding[0].code` (sistema `http://logiacare.ec/fhir/acceso-denegado`).

export const SISTEMA_ACCESO_DENEGADO = 'http://logiacare.ec/fhir/acceso-denegado';
export type CodigoAccesoDenegado = 'sin_vinculo_asistencial' | 'sin_consentimiento_vigente';

/** El motivo de la denegación si el error es de ESTA regla; `null` para cualquier otro error (un 403 de Medplum, un fallo de red...). */
export function accesoDenegadoDe(err: unknown): CodigoAccesoDenegado | null {
  const outcome = (err as { outcome?: { issue?: Array<{ details?: { coding?: Array<{ system?: string; code?: string }> } }> } } | null)?.outcome;
  for (const issue of outcome?.issue ?? []) {
    for (const c of issue.details?.coding ?? []) {
      if (c.system === SISTEMA_ACCESO_DENEGADO && (c.code === 'sin_vinculo_asistencial' || c.code === 'sin_consentimiento_vigente')) return c.code;
    }
  }
  return null;
}
